import { render, staticRenderFns } from "./QuestionSettingsForm.vue?vue&type=template&id=58aeeb1c&"
import script from "./QuestionSettingsForm.vue?vue&type=script&lang=js&"
export * from "./QuestionSettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports